import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ApplicationHttpClient } from '../components/shared/http/application-http-client';

export interface ServiceAlert {
    id: number;
    title: string;
    body: string;
    styleType: 'danger' | 'warn' | 'info';
    actionUrl: string | null;
    actionText: string | null;
}

interface ServiceAlertsResponse {
    alerts: ServiceAlert[];
}

@Injectable({
    providedIn: 'root',
})
export class IncidentBannerService {
    private static readonly TIMEOUT_MS = 5000;

    private _alert$ = new BehaviorSubject<ServiceAlert | null>(null);

    readonly alert$: Observable<ServiceAlert | null> = this._alert$.asObservable();

    constructor(private _http: ApplicationHttpClient) {}

    /**
     * APP_INITIALIZER entry point — fetches once at app startup.
     * Returns an observable so Angular waits for the fetch before bootstrapping.
     * Timeout ensures the app boots even if the API is slow during an incident.
     * No polling — in-app uses Pusher broadcast for live updates.
     */
    initialize(): Observable<ServiceAlertsResponse | null> {
        return this._http.get<ServiceAlertsResponse>(
            environment.LegFiCoreApi + '/api/service-alerts'
        ).pipe(
            timeout(IncidentBannerService.TIMEOUT_MS),
            tap(response => this._alert$.next(response.alerts?.[0] ?? null)),
            catchError(() => {
                this._alert$.next(null);
                return of(null);
            }),
        );
    }
}
